/**
 * The concrete class for making server requests from the app.
 * Extends the core cl-api codelovers module
 * @see codelovers_modules/services/cl-api
 *
 * The only public method of cl-api is the this.request() method which takes the
 * following params:
 *
 * @param  {string}    url      e.g. /getCurrentUser (including the prefix '/')
 * @param  {string}    type     'POST' | 'GET'
 * @param  {object}    params   params to add to the request
 * @param  {boolean}   relogin  if set to true will attempt to re-login if
 *                              401 is received (default: true)
 * @param  {boolean}   cache  disable caching for this request
 * @return {Rx.Observable}
 *
 * The method returns an Rx,Observable which you will need to subscribe
 * to in order to get the response.
 */

//import CLApi from '../codelovers_modules/services/cl-api';

//import CLApi from 'cl-api';
import { CLApi } from 'cl-react'
import _ from 'lodash'

//import Config from '../../config'

// let envs = Config.AVAILABLE_ENVIRONMENTS;
// let selectedEnv = Config.SELECTED_ENV;
// let protocol = Config.USE_HTTPS ? 'https' : 'http';

// let API_URL = protocol + '://' + envs[selectedEnv] + '/index.php/api';

// const API_URL = 'http://markidim.codelovers-solutions.com/api/index.php/api'
// const proxyurl = "https://cors-anywhere.herokuapp.com/https://api.markid.co.il/index.php/api"
// const apiUrl = 'https://api.markid.co.il/index.php/api'
// const API_URL = proxyurl
 const API_URL = 'https://api.markid.co.il/index.php/api'
//const LOCAL_API_URL = 'http://localhost/index.php/api'
const apiUrl = API_URL

class Api extends CLApi {
    signup(
        email,
        password,
        firstName,
        id,
        lastName,
        choreographerType,
        memberId,
        cellularNumber,
        phoneNumber,
        address
    ) {
        return this.request(
            'signup',
            'POST',
            {
                email,
                password,
                firstName,
                id,
                lastName,
                choreographerType,
                memberId,
                cellularNumber,
                phoneNumber,
                address,
            },
            true,
            false,
            apiUrl
        )
    }

    login(email, password, accessToken = null) {
        return this.request(
            'login',
            'POST',
            { email: email?.trim(), password, access_token: accessToken, rememberMe: true },
            true,
            false,
            apiUrl
        )
    }

    getCurrentUser() {
        return this.request(
            'get_current_user',
            'POST',
            {},
            true,
            false,
            apiUrl
        )
    }

    logout() {
        return this.request('logout', 'POST', {}, true, false, apiUrl)
    }

    resetPassword(email, password) {
        return this.request(
            'reset_password',
            'POST',
            { email, password },
            true,
            false,
            apiUrl
        )
    }

    forgotPassword(email) {
        return this.request(
            'forgot_password',
            'POST',
            { email },
            true,
            false,
            apiUrl
        )
    }

    getAllUsers(
        page = 1,
        pageSize = 10,
        orderBy = [],
        search = '',
        filter = []
    ) {
        
        return this.request(
            'get_all_users',
            'POST',
            { page, page_size: pageSize, orderby: orderBy, filter, search },
            true,
            false,
            apiUrl
        )
    }

    getUserById(id) {
        return this.request(
            'get_user_by_id',
            'POST',
            { id },
            true,
            false,
            apiUrl
        )
    }

    deleteUser() {
        return this.request('delete_user', 'POST', {}, true, false, apiUrl)
    }

    saveUser(user) {
        console.log(
            ' from  saveUser   user = ',
            user
        )
        return this.request('save_user', 'POST', { user }, true, false, apiUrl)
    }

    setUserIsDisabled(user_id, disabled) {
        return this.request(
            'set_user_is_disabled',
            'POST',
            { user_id, disabled },
            true,
            false,
            apiUrl
        )
    }

    saveDance(dance) {
        console.log(dance,'ddaanncceeeeee!!!!!');
        return this.request(
            'save_dance',
            'POST',
            { dance },
            true,
            false,
            apiUrl
        )
    }

    payment($user) {
        return this.request('payment', 'POST', {}, true, false, apiUrl)
    }

    mailToUsers($distribution, $message_header, $content) {
        return this.request('mailToUsers', 'POST', {}, true, false, apiUrl)
    }

    messageToUserDanceApproved($content) {
        return this.request(
            'messageToUserDanceApproved',
            'POST',
            {},
            true,
            false,
            apiUrl
        )
    }

    messageToUserDanceRejected($content) {
        return this.request(
            'messageToUserDanceRejected',
            'POST',
            {},
            true,
            false,
            apiUrl
        )
    }

    messageToUserDanceExpired($content) {
        return this.request(
            'messageToUserDanceExpired',
            'POST',
            {},
            true,
            false,
            apiUrl
        )
    }

    termsOfService($content) {
        return this.request('termsOfService', 'POST', {}, true, false, apiUrl)
    }

    welcomeMessage($content) {
        return this.request('welcomeMessage', 'POST', {}, true, false, apiUrl)
    }

    explanations($content) {
        return this.request('explanations', 'POST', {}, true, false, apiUrl)
    }
    getDanceStylesOptions() {
        return this.request(
            'get_dance_styles_options',
            'GET',
            {},
            true,
            false,
            apiUrl
        )
    }
    getDanceStatusesOptions() {
        return this.request(
            'get_dance_statuses_options',
            'GET',
            {},
            true,
            false,
            apiUrl
        )
    }
    getAllDances(
        page = 1,
        pageSize = 10,
        orderBy = [],
        search = '',
        filter = [],
        exportData = false
    ) {
        return this.request(
            'get_all_dances' +
                (exportData ? '_csv' + window.location.search : ' '),
            exportData ? 'GET' : 'POST',
            exportData
                ? {}
                : {
                      page,
                      page_size: pageSize,
                      orderby: orderBy,
                      filter,
                      search,
                  },
            true,
            false,
            apiUrl
        )
    }

    getFilterOptions(collection, property, subProperty, inputText) {
        return this.request(
            'get_filter_options',
            'POST',
            {
                collection,
                property,
                sub_property: subProperty,
                input_text: inputText,
            },
            true,
            false,
            apiUrl
        )
    }
    acumSearchByTerm(term) {
        return this.request(
            'acum_search_song_by_term',
            'POST',
            { term },
            true,
            false,
            apiUrl
        )
    }
    acumSearchById(id) {
        return this.request(
            'acum_get_song_details',
            'POST',
            { work_id: id },
            true,
            false,
            apiUrl
        )
    }

    getDanceById(id) {
        return this.request(
            'get_dance_by_id',
            'GET',
            { id },
            true,
            false,
            apiUrl
        )
    }

    getDanceByAkumId(akum_id) {
        return this.request(
            'get_dance_by_akum_id',
            'POST',
            { akum_id },
            true,
            false,
            apiUrl
        )
    }

    setDanceStatus(dance_id, status) {
        return this.request(
            'set_dance_status',
            'POST',
            { dance_id, status },
            true,
            false,
            apiUrl
        )
    }

    deleteDance(dance_id, reason) {
        return this.request(
            'delete_dance',
            'POST',
            { dance_id, reason },
            true,
            false,
            apiUrl
        )
    }

    getAppConfig() {
        return this.request('get_app_config', 'POST', {}, true, false, apiUrl)
    }

    saveAppConfig(app_config) {
        return this.request(
            'save_app_config',
            'POST',
            { app_config },
            true,
            false,
            apiUrl
        )
    }

    sendGeneralEmail(group, subject, body) {
        return this.request(
            'send_general_email',
            'POST',
            { group, subject, body },
            true,
            false,
            apiUrl
        )
    }

    getAllLogs(
        page = 1,
        page_size = 10,
        orderby = [],
        search = '',
        filter = [],
        from_date,
        to_date,
        user_type,
        
    )
     {
        return this.request(
            'get_all_logs',
            'POST',
            {
                page,
                page_size,
                orderby,
                filter,
                search,
                from_date,
                to_date,
                user_type,
                
            },
            true,
            false,
            apiUrl
        )
    }

    exportCsv(collection, search) {
        if (collection === 'dances') {
            return this.request(
                'get_all_dances_csv',
                'GET',
                {
                    search,
                },
                true,
                false,
                apiUrl
            )
        }
    }
}

const api = new Api()
export default api
